<mat-form-field>
    <input
        matInput
        placeholder="{{ settings?.placeholder | translate }}"
        [(ngModel)]="value" [disabled]="!editable">
    <button mat-button *ngIf="value && editable" matSuffix mat-icon-button (click)="reset()">
        <mat-icon>close</mat-icon>
    </button>
</mat-form-field>